import React from 'react';

import { useBooking } from '@/booking';
import { ConfirmationHeader } from '@/booking-confirmation';
import { BookingRequest } from '@/booking/interfaces';
import { useHotel } from '@/hotel';
import { useTranslation } from '@/i18n';

interface AmendmentConfirmationHeaderProps {
  bookingRequest: BookingRequest;
}

export const AmendmentConfirmationHeader: React.FC<
  AmendmentConfirmationHeaderProps
> = ({ bookingRequest }) => {
  const booking = useBooking(bookingRequest);
  const hotel = useHotel(bookingRequest.hotelSlug);
  const { t } = useTranslation(['confirmation', 'bookingManagement']);

  if (!booking || !hotel) return null;

  return (
    <ConfirmationHeader
      title={t('confirmation:title', {
        city: hotel.location.address.city,
        name: hotel.name,
      })}
      subtitle={t('confirmation:subtitle')}
      confirmationMessage={t(
        'bookingManagement:confirmation.emailConfirmationMessage',
        {
          email: booking.firstRoomStay.billerProfile.email,
        }
      )}
      headerImage={hotel.content.images.header}
    />
  );
};
